<template>
  <div class="relative isolate">
    <img
      :src="image"
      alt=""
      :width="isMobile ? 820 : 1920"
      :height="isMobile ? 372 : 840"
      decoding="async"
      class="absolute inset-0 -z-10 size-full object-cover object-[center_66%]"
    >

    <div
      aria-hidden="true"
      class="absolute inset-0 -z-10 md:hidden bg-black/20"
    />

    <div
      v-if="showCanadianOwnerBanner"
      aria-hidden="true"
      class="hidden md:block absolute inset-x-0 h-full -z-10 transform-gpu overflow-hidden bg-linear-to-b from-black/20 to-transparent"
    />

    <TContainer
      size="xl"
      class="py-16 sm:pb-48 md:pt-20 md:pb-56 lg:pt-24 lg:pb-72"
    >
      <slot />
    </TContainer>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  image: string
}>()

const { isMobile } = useDevice()

const { showCanadianOwnerBanner } = useExperiment()
</script>
